import React, { FC, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { PlainDropDown } from 'src/common';
import { useUpdateBidTasks } from 'src/models/bids/BidTask/hooks';
import { RequirementType } from 'src/models/bids/BidTask/types';
import classNames from 'classnames';
import { BidTask } from 'src/models/bids/BidTask';

interface Props {
  questions: BidTask[];
  groupId: string;
  taskValue?: RequirementType | null;
  className?: string;
  disabled?: boolean;
}

export const TaskRequirementPicker: FC<Props> = ({ questions, groupId, taskValue, className, disabled }) => {
  const { t } = useTranslation();
  const [updateTasks] = useUpdateBidTasks();
  const values = useMemo(
    () =>
      Object.values(RequirementType).map(type => {
        const label = Object.keys(RequirementType).find(
          key => RequirementType[key as keyof typeof RequirementType] === type
        );
        return {
          value: type,
          label: t(`BiddingTool.RequirementType.${label}`)
        };
      }),
    [t]
  );

  const onChangeResponse = useCallback(
    (requirementType: RequirementType | 'null') => {
      updateTasks({
        questions: questions.filter(item => item.requirementType !== requirementType),
        groupId,
        requirementType: requirementType === 'null' ? null : requirementType
      });
    },
    [groupId, questions, updateTasks]
  );

  return (
    <PlainDropDown
      values={values}
      selectedValue={taskValue ?? undefined}
      label={t('Common.notSet')}
      onSelect={onChangeResponse}
      hideLabel
      className={classNames(styles.picker, { [styles.notSet]: taskValue === null }, className)}
      placeholder={t('BiddingTool.requirementTitle')}
      type="single"
      disabled={disabled}
    />
  );
};

export default TaskRequirementPicker;
